import React from 'react';
import Permission from '../../components/Permission';
import MetaTitle from '../../components/MetaTitle';
import useFetch from '../../hooks/useFetch';
import Table from '../../components/Table';
import { Animation, Button, Status } from '../../assets/global/globalStyles';
import { Button as ButtonCreate } from './styles';
import { fetchAccounts } from '../../store/accounts';
import { AddBoxOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { ALL_GROUPS } from '../../global/variables/userGroups';
import USER_ROLES from '../../global/variables/userRoles';

export default function Users() {
  const navigate = useNavigate();
  const { data: accounts } = useFetch(
    fetchAccounts({
      url: '/user/getuser-by-user-admin',
      method: 'GET',
    }),
    'accounts',
  );

  const dataUpdateObject = React.useMemo(() => {
    const typeName = {
      A: 'Ativo',
      B: 'Bloqueado',
      I: 'Inativo',
    };
    return accounts.map((item) => ({ ...item, _: typeName[item.status] }));
  }, [accounts]);

  const editUser = (id) => navigate(`/dashboard/edituser/${id}`);
  return (
    <>
      <MetaTitle title="Usuários" />
      <Animation>
        <Permission
          roles={[USER_ROLES.Administrador]}
          groups={ALL_GROUPS}
          component={() => (
            <ButtonCreate to="/dashboard/createuser">
              <AddBoxOutlined style={{ width: '25px', height: '25px' }} />
              Adicionar Usuário
            </ButtonCreate>
          )}
        />
        <Table
          columns={['name', 'email', 'userGroup', 'role', 'status']}
          columnNames={['Nome', 'E-mail', 'Grupo', 'Perfil', 'Status']}
          data={dataUpdateObject}
          title="Gerenciamento de Usuários"
          keyStorage="users_filter"
          columnsModify={{
            userGroup: (value) => {
              const typeName = {
                CPFL_DEPOSITO: 'DEPÓSITO', //TODO review this map to be dynamic
                RGE_DEPOSITO: 'DEPÓSITO',
                CPFL_GERENCIAL: 'CPFL',
                CPFL: 'CPFL',
                RGE: 'RGE',
                DHL: 'DHL',
              };
              return typeName[value];
            },
            status: (value) => {
              const typeName = {
                A: <Status typeName="success">Ativo</Status>,
                B: <Status typeName="danger">Bloqueado</Status>,
                I: <Status typeName="welcome">Inativo</Status>,
              };
              return typeName[value];
            },
          }}
          columnButtons={[
            ({ id }) => (
              <Button typeName="welcome" onClick={() => editUser(id)}>
                Ver
              </Button>
            ),
          ]}
        />
      </Animation>
    </>
  );
}
